import styled from 'styled-components'
import { H2 } from '../common/H2'

export const WhiteLabelHeader = styled(H2)`
  font-size: 26px;
  margin-top: 0.2em;
  color: ${(props) => props.theme.primaryColour};
  text-transform: uppercase;
`

export const HeaderContainer = styled.div`
  width: 80%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 70px;
  grid-column-gap: 10px;

  @media (max-width: 375px) {
    display: flex;
    justify-content: space-between;
  }
`

export const TeslaBrand = styled.div`
  align-content: space-evenly;

  &:after {
    content: ' ';
    clear: both;
  }

  @media (max-width: 768px) {
    float: left;
  }

  @media (max-width: 375px) {
    display: flex;
    align-items: center;
    width: 170px;
  }
`

export const HeaderLinkWrapper = styled.div`
  float: right;
  display: flex;
  align-items: center;
`
